/*
=========================================================
   __                 ____  _
  |   \  ___  __ __  |  _ || |  _ _   ___
  | |) |/ -_) \ V /  |  __|| | | | | / -_)
  |___/ \___|  \_/   |_|   |_| \_,_| \___| o o o   

=========================================================

  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import Dashboard from "layouts/dashboard/Dashboard";
import DealerPackage from "layouts/setting/DealerPackage";
import Log from "layouts/tool/Log";
import MenuMain from "layouts/tool/MenuMain";
import PermissionMain from "layouts/tool/PermissionMain";
import Logout from "layouts/user/Logout";
import Profile from "layouts/user/Profile";
import Task from "layouts/user/Task";
import User from "layouts/user/User";
import Sales from "layouts/dashboards/sales";
import Product from "layouts/product/Product";
import Category from "layouts/setting/Category";
import Member from "layouts/member/Member";
import SaleOrder from "layouts/order/SaleOrder";
import Course from "layouts/order/Course";
import Manual from "layouts/setting/Manual";

const routes = [
  {
    type: "collapse",
    name: "",
    key: "avatar",
    icon: null,
    collapse: [
      {
        name: "menu.profile",
        key: "profile",
        route: "/profile",
        component: <Profile />,
      },
      {
        name: "menu.changepassword",
        key: "changepassword",
        route: "/changepassword",
        component: <Dashboard />,
      },
      {
        name: "menu.logout",
        key: "logout",
        route: "/logout",
        component: <Logout />,
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "menu.dashboard",
    key: "dashboard_menu",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "menu.dashboard_admin",
        key: "dashboard_admin",
        route: "/dashboard_admin",
        component: <Dashboard />,
      },
      {
        name: "menu.dashboard_sell",
        key: "dashboard_sell",
        route: "/dashboard_sell",
        component: <Sales />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.saleorder",
    key: "saleorder_menu",
    icon: <Icon fontSize="medium">directions_car</Icon>,
    collapse: [
      {
        name: "menu.saleorder",
        key: "saleorder",
        route: "/saleorder",
        component: <SaleOrder />,
      },
      {
        name: "menu.course",
        key: "tradertool",
        route: "/course",
        component: <Course />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.product",
    key: "product_menu",
    icon: <Icon fontSize="medium">directions_car</Icon>,
    collapse: [
      {
        name: "menu.product",
        key: "product",
        route: "/product",
        component: <Product />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.member",
    key: "member_menu",
    icon: <Icon fontSize="medium">directions_car</Icon>,
    collapse: [
      {
        name: "menu.member",
        key: "member",
        route: "/member",
        component: <Member />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.user",
    key: "user_menu",
    icon: <Icon fontSize="medium">assignment_ind</Icon>,
    collapse: [
      {
        name: "menu.staff",
        key: "staff",
        route: "/staff",
        component: <User />,
      },
      {
        name: "menu.task",
        key: "task",
        route: "/task",
        component: <Task />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.setting",
    key: "setting_menu",
    icon: <Icon fontSize="medium">settings</Icon>,
    collapse: [
      {
        name: "menu.category",
        key: "category",
        route: "/category",
        component: <Category />,
      },
      {
        name: "menu.manual",
        key: "manual",
        route: "/manual",
        component: <Manual />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.tool",
    key: "tool_menu",
    icon: <Icon fontSize="medium">admin_panel_settings</Icon>,
    collapse: [
      {
        name: "menu.menu",
        key: "menu",
        route: "/menu",
        component: <MenuMain />,
      },
      {
        name: "menu.permission",
        key: "permission",
        route: "/permission",
        component: <PermissionMain />,
      },
      {
        name: "menu.log",
        key: "log",
        route: "/log",
        component: <Log />,
      },
    ],
  },
];

export default routes;
